import { Component, input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'mwe-tariff-selection-card-ui-row',
  templateUrl: './tariff-selection-card-ui-row.component.html',
  imports: [NgClass],
})
export class TariffSelectionCardUiRowComponent {
  isReadOnly = input<boolean>();
}
